import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DirectDebitResponse } from '../../entities/direct-debit.entity';
import { ServedByOptionType } from '../../entities/served-by-option.entity';

export const sepaActions = createActionGroup({
  source: 'Sepa',
  events: {
    'load has sepa': emptyProps(),
    'toggle sepa': props<{ useDirectDebit: boolean }>(),
    'load options': emptyProps(),
    'change option': props<{ optionType: ServedByOptionType }>(),
    'reset options': emptyProps(),
    'display success hint': emptyProps(),
  },
});

export const sepaApiActions = createActionGroup({
  source: 'Sepa API',
  events: {
    'load has sepa success': props<{ hasSepa: boolean }>(),
    'load has sepa failure': props<{ error: HttpErrorResponse }>(),
    'toggle sepa success': props<{ response: DirectDebitResponse }>(),
    'toggle sepa failure': props<{ error: HttpErrorResponse }>(),
  },
});
